import { actresses, type Actress } from "@/mocks/actresses";
import { works, type Work } from "@/mocks/works";
import { newsList, type NewsItem } from "@/mocks/news";

export function getActressById(id: string): Actress | undefined {
  return actresses.find((item) => item.id === id);
}

export function getWorkById(id: string): Work | undefined {
  return works.find((item) => item.id === id);
}

export function getNewsById(id: string): NewsItem | undefined {
  return newsList.find((item) => item.id === id);
}

export function getActressNames(work: Work): string[] {
  return work.actressIds
    .map((id) => getActressById(id)?.name)
    .filter((name): name is string => Boolean(name));
}

export function getActressesOfWork(work: Work): Actress[] {
  return work.actressIds
    .map((id) => getActressById(id))
    .filter((item): item is Actress => Boolean(item));
}

export function getWorksByActress(actressId: string): Work[] {
  return works.filter((work) => work.actressIds.includes(actressId));
}

export function getNewsByActress(actressId: string): NewsItem[] {
  return newsList.filter((item) => item.relatedActressIds.includes(actressId));
}

export function getRelatedWorks(work: Work, limit = 4): Work[] {
  return works
    .filter((item) => item.id !== work.id && item.genres.some((genre) => work.genres.includes(genre)))
    .sort((a, b) => b.rating - a.rating)
    .slice(0, limit);
}

export function getRelatedActresses(actress: Actress, limit = 4): Actress[] {
  return actresses
    .filter(
      (item) =>
        item.id !== actress.id &&
        (item.agency === actress.agency || item.genres.some((genre) => actress.genres.includes(genre))),
    )
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, limit);
}

export function getPopularActresses(limit = 5): Actress[] {
  return [...actresses].sort((a, b) => b.popularity - a.popularity).slice(0, limit);
}

export function getPopularWorks(limit = 12): Work[] {
  return [...works].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatestNews(limit = 5): NewsItem[] {
  return [...newsList].sort((a, b) => b.date.localeCompare(a.date)).slice(0, limit);
}